import './AxisArea.css';
export var axisContainerStyle = '_bidc430-3-12-1';